<dialog
  #dialog
  (click)="backgroundClick($event)"
  [ngClass]="{
    'info-dialog': isInfoDialog(),
    'allow-overflow': allowOverflow(),
  }"
  class="dialog-container"
>
  <div
    #dialogContent
    (click)="stopPropagation($event)"
    class="dialog-frame"
    [ngClass]="{
      scroll: enableScrollWhenOverFlow(),
      'scroll-content': scrollableContent,
    }"
  >
    @if (showErrorNotification()) {
      <notification-bar icon="a-icon ui-ic-alert-warning" type="warning">
        Your bookmark couldn't be created
      </notification-bar>
    }

    <section class="title-wrapper">
      <div class="warning-icon-title-container">
        @if (displayWarningIcon()) {
          <i class="a-icon boschicon-bosch-ic-alert-warning-filled warning-icon"></i>
        }

        <h2 class="title title-desktop">{{ title() }}</h2>
        <h2 class="title title-mobile">{{ mobileTitle() || title() }}</h2>
      </div>

      @if (shouldShowCloseButton()) {
        <i
          (click)="closeDialog()"
          class="cursor-pointer a-icon ui-ic-close close-icon"
        ></i>
      }
    </section>

    <section
      class="dialog-content mt-4 mb-4"
      [ngClass]="{
        'dialog-content-center': contentCenter(),
      }"
    >
      <ng-content></ng-content>
    </section>
    @if (buttonsTemplate() || isSecondaryButtonEnabled() || isPrimaryButtonEnabled() || isTertiaryButtonEnabled()) {
      <section class="dialog-footer">
        <div
          class="button-container flex items-center justify-start gap-4 p-4 mb-[5px] md:py-4 md:px-8"
        >
          @if (buttonsTemplate()) {
            <ng-container [ngTemplateOutlet]="buttonsTemplate()"></ng-container>
          } @else {
            @if (isSecondaryButtonEnabled()) {
              <app-button
                (click)="secondaryButtonClickedMethod($event)"
                [buttonLabel]="secondaryButtonName()"
                [buttonType]="ButtonTypeEnum.SECONDARY"
                [isDisabled]="secondaryButtonDisabled()"
              />
            }

            @if (isPrimaryButtonEnabled()) {
              <app-button
                (click)="primaryButtonClickedMethod($event)"
                [buttonLabel]="primaryButtonName()"
                [buttonType]="ButtonTypeEnum.PRIMARY"
                [isDisabled]="primaryButtonDisabled()"
              />
            }

            @if (isTertiaryButtonEnabled()) {
              <app-button
                (click)="tertiaryButtonClickedMethod($event)"
                [buttonLabel]="tertiaryButtonName()"
                [buttonType]="ButtonTypeEnum.SECONDARY"
                [isDisabled]="tertiaryButtonDisabled()"
              />
            }
          }
        </div>
      </section>
    }

    <div #floatingDialog class="floating-dialog" popover="manual"></div>
  </div>
</dialog>
